import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

import IconRemove from '@/assets/icons/ic-remove-white.svg';
import IconEdit from '@/assets/icons/ic-edit-white.svg';

export const ImageUploaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const ImageUploaderBox = styled.img`
  border-radius: 10px;
  background-color: ${colors.gray100} !important;
  box-shadow: 0 0 0 1px ${colors.gray200};
  cursor: pointer;
  margin-bottom: 10px;
`;

export const ImagePreview = styled.div<{ src: string }>`
  position: relative;
  width: 90px;
  height: 90px;
  cursor: pointer;
  border-radius: 4px;
  background-color: ${colors.gray600};
  background-image: url(${(props) => props.src});
  background-position: center;
  background-size: cover;
  border: 1px solid ${colors.gray200};
  margin-right: 10px;
  margin-bottom: 10px;
`;

export const IconButton = styled.button<{ Icon: typeof IconRemove | typeof IconEdit }>`
  width: 100%;
  background-image: url(${(props) => props.Icon});
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  outline: none;
`;

export const ImageController = styled.div`
  position: absolute;
  background-color: ${colors.blackOpacity400};
  bottom: 10px;
  border-radius: 0px 0 4px 4px;
  width: 90px;
  height: 30px;
  display: flex;
  justify-content: space-around;
`;

export const LoadingSkeletonBox = styled.div`
  width: 90px;
  height: 90px;
  margin-right: 10px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid ${colors.gray200};
  border-radius: 10px;
`;
